import { TemplateRef, Component, ContentChildren, QueryList, ViewChildren, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Services.
import { ToastService } from '@services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { WebsocketService } from '@services/websocket.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ServerService } from '@services/server.service';
import { ApiServerService } from '@services/api-server.service';
import { QsignerService } from '@services/qsigner.service';
// import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

// Para las traducciones.
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale, ptBrLocale, enGbLocale } from 'ngx-bootstrap/locale';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

// Entorno.
import { environment } from '@environments/environment';

// Helpers
import { scrollToTop, obtainApi, setToken, comprobarNativo, obtainTokenAndCompanyParamsSigner, showToaster, manageAES } from '@helpers';
import { keys } from 'cypress/types/lodash';

// Establecer lenguaje.
defineLocale('es', esLocale);

@Component({
  selector: 'qsigner',
  templateUrl: './qSigner.component.html',
  styleUrls: ['./qSigner.component.scss'],
})
export class QSignerComponent implements OnInit {
  // Params in URL
  private auths: any;
  private signs: any;
  private idIdioma: any;
  private idCliente: any;
  private url: string;

  public name: string = 'valor';
  public id: any;
  public category: any;
  public message!: string;
  public user: any;
  public idEvento!: string;
  public userUrl!: string;

  // Banderas.
  public blockBody!: boolean;
  public ButtonSendingInfo: boolean = false;
  public blockbuttonSend: boolean = true;
  public loadingData: boolean;
  public sendingData!: boolean;
  public dataSent!: boolean;
  public noSigns: boolean = false;
  public noAuths: boolean = false;
  public documentId: any;
  public isNative: any;
  public btnSendData: boolean = true;
  // Bandera: Para mostrar la lista de documentos.
  public showDocumentList: boolean;

  // Para los service params.
  public sp: any;

  // PDF params
  public page: number = 1;
  public totalPages!: number;
  public isLoaded: boolean = false;
  public zoom: number = 1;
  public locale: any;
  public reference: any;
  public qbrowser: any;
  public eventID: any;
  public last: any;
  public heightCanvas: any;

  // Listas.
  public urlParams: any = [];
  public idsAuthorization: any[] = [];
  public authorizations: any[] = [];
  public signatures: any[] = [];
  public idsSignature: any = [];
  public idsTabs: any = [];
  public idsTabsets: any = [];
  public idsButtons: any = [];
  public respuesta: any = {};
  public documentos: any = {};
  public model: any = {};

  // Childs.
  @ContentChildren(QSignerComponent)
  public form!: QueryList<QSignerComponent>;
  @ViewChildren('signature')
  public firmas!: QueryList<any>;
  @ViewChildren('tab')
  public tab!: QueryList<QSignerComponent>;
  @ViewChildren('info')
  public info!: QueryList<QSignerComponent>;
  @ViewChild('template')
  public template!: TemplateRef<any>;

  public constructor(
    private toastService: ToastService,
    private translateService: TranslateService,
    public storage: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    public localeService: BsLocaleService,
    public qsigner: QsignerService,
    public serverService: ServerService,
    public apiServerService: ApiServerService,
    public websocketService: WebsocketService
  ) {
    // Establecer valores iniciales por defecto.
    this.url = '';
    this.loadingData = false;
    this.showDocumentList = false;
  }

  ngOnInit(): void {
    this.storage.clear('signer');
    this.url = environment.url;
    comprobarNativo().then((resultado: any) => {
      this.isNative = resultado;
    });
    this.loadingData = true;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.urlParams = Object.keys(params);
      for (var i = 0; i < this.urlParams.length; i++) {
        switch (this.urlParams[i]) {
          case 'id':
            this.id = params[this.urlParams[i]];
            break;
          case 'eid':
            this.id = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'auths':
            this.auths = params[this.urlParams[i]];
            break;
          case 'eauths':
            this.auths = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'signs':
            this.signs = params[this.urlParams[i]];
            break;
          case 'esigns':
            this.signs = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'idCliente':
            this.idCliente = params[this.urlParams[i]];
            break;
          case 'eidCliente':
            this.idCliente = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'idIdioma':
            this.idIdioma = params[this.urlParams[i]];
            break;
          case 'eidIdioma':
            this.idIdioma = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'category':
            this.category = params[this.urlParams[i]];
            break;
          case 'ecategory':
            this.category = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'user':
            this.user = params[this.urlParams[i]];
            break;
          case 'euser':
            this.user = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'qbrowser':
            this.qbrowser = params[this.urlParams[i]];
            break;
          case 'eqbrowser':
            this.qbrowser = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'eventID':
            this.eventID = params[this.urlParams[i]];
            break;
          case 'eeventID':
            this.eventID = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
          case 'last':
            this.last = params[this.urlParams[i]];
            break;
          case 'elast':
            this.last = manageAES(encodeURI(params[this.urlParams[i]].replace(/ /g, '+')), 'decrypt');
            break;
        }
      }

      if (((!this.category && !this.id && !this.idIdioma && !this.idCliente && !this.user) || !this.signs || !this.auths || this.qbrowser) && !this.signs && !this.auths) {
        setTimeout(() => {
          this.toastService.new('error', 'ERROR', 'Se ha producido un error al obtener los datos');
        });
      } else {
        if (this.idIdioma) {
          switch (this.idIdioma) {
            case 'es':
              this.locale = esLocale;
              this.idIdioma = 'es';
              break;
            case 'pt':
              this.locale = ptBrLocale;
              this.idIdioma = 'pt';
              break;
            case 'en':
              this.locale = enGbLocale;
              this.idIdioma = 'en';
              break;
            case 'ES':
              this.locale = esLocale;
              this.idIdioma = 'es';
              break;
            case 'PT':
              this.locale = ptBrLocale;
              this.idIdioma = 'pt';
              break;
            case 'EN':
              this.locale = enGbLocale;
              this.idIdioma = 'en';
              break;
            default:
              this.locale = esLocale;
              this.idIdioma = 'es';
              break;
          }

          defineLocale(this.idIdioma, this.locale);
          this.localeService.use(this.idIdioma);
          this.translateService.setDefaultLang(this.idIdioma);
        }
        // Obtener datos del documento.
        let params: any = this.id.split('*');
        this.reference = params[1];
        this.documentId = params[0];
        this.userUrl = params[2];
        this.idEvento = '1';

        obtainApi(this.qsigner, this.url, this.toastService).then((api) => {
          obtainTokenAndCompanyParamsSigner(api, this.storage, this.qsigner, this.toastService, this.apiServerService, this.url, this.idCliente).then((serviceParams: any) => {
            // Com probar si tiene o no tiene acceso a la api.
            if (serviceParams === 'NO_CLIENT') {
              showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', 'COMMON.ERROR_CLIENT');
              this.loadingData = false;
              this.showDocumentList = true;
            } else {
              // Coger los datos de la api.
              this.sp = serviceParams;
              // Obtener los documentos.
              this.obtainSings(serviceParams['token'], serviceParams['companyParams']);
            }
          });
        });
      }
    });
  }

  // Obtener firmas.
  private obtainSings(token: any, apiDealership: any): void {
    let obj: any = {};
    obj['documento'] = {};
    obj['token'] = token;
    obj['companyParams'] = apiDealership;
    this.eventID ? (obj['documento']['eventId'] = this.eventID) : undefined;
    if (this.auths) {
      obj['documento']['authorizationId'] = this.auths;
    } else {
      this.noAuths = true;
    }

    if (this.signs) {
      obj['documento']['signatureId'] = this.signs;
    } else {
      this.noSigns = true;
    }

    if (this.category) {
      obj['documento']['category'] = this.category;
    }
    obj['documento']['reference'] = this.reference;
    if ((obj['documento'] && obj['documento']['authorizationId']) || obj['documento']['signatureId']) {
      this.qsigner.getSigns(this.url, obj).subscribe((datos: any) => {
        if (datos && datos.tokenObj && datos.api) {
          setToken(datos.api, datos.tokenObj, this.storage);
        }
        console.log('[QSigner] Loaded data: ', datos);
        this.documentos = datos;
        this.loadingData = false;
        // Authorizaciones.
        if (this.documentos) {
          if (this.documentos.authorization && this.documentos.authorization.length > 0) {
            for (let i = 0; i < this.documentos.authorization.length; i++) {
              this.idsAuthorization.push('authorization-' + this.documentos.authorization[i].authorizationId);
              this.documentos.authorization[i]['authorizationText'] = this.htmlDecode(this.documentos.authorization[i]['authorizationText']);
              if (this.documentos.authorization[i] && this.documentos.authorization[i].fixedValue && this.documentos.authorization[i].fixedValue.indexOf('~') >= 0) {
                var camposSplit = this.documentos.authorization[i].fixedValue.split('~');
                this.documentos.authorization[i].fixedValue = camposSplit;
              }
              this.documentos.authorization[i]['visible'] = true;
              this.authorizations.push(this.documentos.authorization[i]);
            }
            this.documentos.authorization = this.authorizations;
          }
        }
        // Firmas.
        if (this.documentos) {
          if (this.documentos.signatures && this.documentos.signatures.length > 0) {
            for (let i = 0; i < this.documentos.signatures.length; i++) {
              this.idsSignature.push('signature-' + this.documentos.signatures[i].signatureId);
              this.documentos.signatures[i]['visible'] = true;
              this.documentos.signatures[i]['btnVisible'] = false;
              this.signatures.push(this.documentos.signatures[i]);
            }
            this.documentos.signatures = this.signatures;
          }
        }
      });
    }
  }

  // Para formatear el texto.
  public htmlDecode(input: any): any {
    return input
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&#243;/g, 'ó')
      .replace(/&#095;/g, '_')
      .replace(/&#224;/g, 'á');
  }

  // Preparar datos para el envio al DMS.
  public sendData(): void {
    // Listas.
    let arraySignatures: any[] = [];
    let arrayAuthorization: any[] = [];
    let signaruresIdList: string = '';
    let authorizationsIdList: string = '';
    // Banderas.
    let isRequiredSignatures: boolean = true;
    let isRequiredAuthorizations: boolean = true;
    // Comprobar firmas requeridas.
    if (this.documentos.signatures && this.documentos.signatures.length) {
      this.documentos.signatures.forEach((element: any) => {
        if (element.required === true) {
          if (element.signature === undefined) {
            isRequiredSignatures = false;
          }
        }
      });
    }
    // Comprobar autorizaciones requeridas.
    if (this.documentos.authorization && this.documentos.authorization.length) {
      this.documentos.authorization.forEach((element: any) => {
        if (element.required === true) {
          if (element.signature === undefined) {
            isRequiredAuthorizations = false;
          }
        }
      });
    }
    // Comprobar que todos los campos requeridos están.
    if (isRequiredSignatures && isRequiredAuthorizations && this.documentId && this.reference && this.userUrl && this.idEvento && this.idCliente && this.category) {
      // Obtener array de firmas.
      if (this.documentos.signatures && this.documentos.signatures.length) {
        this.documentos.signatures.forEach((element: any) => {
          // Crear estructura.
          let obj = {
            signatureId: element['signatureId'].split('_')[1],
            signature: element['signature'],
          };
          // Añadir firma al array.
          arraySignatures.push(obj);
        });
      }
      // Obtener array de ids de firmas.
      if (this.documentos.signatures && this.documentos.signatures.length) {
        this.documentos.signatures.forEach((element: any, index: number) => {
          // Crear estructura.
          if (index === 0) {
            signaruresIdList += element['signatureId'].split('_')[1];
          } else {
            signaruresIdList += ',' + element['signatureId'].split('_')[1];
          }
        });
      }
      // Obtener array de autorizaciones.
      if (this.documentos.authorization && this.documentos.authorization.length) {
        this.documentos.authorization.forEach((element: any) => {
          let authorizationResult = '';
          if (Array.isArray(this.model)) {
            this.model.forEach((element: any) => {
              if (element['authorizationId'] === element) {
                authorizationResult = element;
              }
            });
          } else {
            authorizationResult = this.model;
          }

          // Crear estructura.
          let obj = {
            authorizationId: element['authorizationId'],
            authorizationResult: authorizationResult[element['authorizationId']],
          };
          // Añadir autorizaciones al array.
          arrayAuthorization.push(obj);
        });
      }
      // Obtener array de autorizaciones.
      if (this.documentos.authorization && this.documentos.authorization.length) {
        this.documentos.authorization.forEach((element: any, index: number) => {
          // Crear estructura.
          if (index === 0) {
            authorizationsIdList += element['authorizationId'];
          } else {
            authorizationsIdList += ',' + element['authorizationId'];
          }
        });
      }
      // Crear estructura de la petición.
      this.respuesta = {
        respuesta: {
          signatureId: signaruresIdList,
          signatures: arraySignatures,
          documentId: this.documentId + '*' + this.reference + '*' + this.userUrl + '*' + this.idEvento + '*' + this.idCliente,
          headText: 'string',
          deviceId: 'string',
          category: this.category,
          authorizationId: authorizationsIdList,
          authorization: arrayAuthorization,
        },
      };
      console.warn('[Respuesta]: ', this.respuesta);
      // Envio de firmas.
      obtainApi(this.qsigner, this.url, this.toastService).then((api) => {
        obtainTokenAndCompanyParamsSigner(api, this.storage, this.qsigner, this.toastService, this.apiServerService, this.url, this.idCliente).then((serviceParams) => {
          this.postSignatures(serviceParams['token'], serviceParams['companyParams']);
        });
      });
    }
  }

  // Resetear autorizacion.
  public borrarAuthorization(id: any): void {
    let expresion = id.split('-')[0];
    let identifier = id.split('-')[1];
    let keys;
    switch (expresion) {
      case 'checkbox':
        let keysCheck = Object.keys(this.model);
        let keysCheckLength = keysCheck.length;
        if (keysCheck && keysCheck.length > 0) {
          for (let i = 0; i < keysCheckLength; i++) {
            let inputs: any = document.querySelectorAll('#' + id + ' input');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier && inputs[j].checked) {
                  inputs[j].checked = false;
                  delete this.model[inputs[j].id];
                }
              }
            }
          }
        }
        delete this.model['checkbox-data'];
        break;
      case 'radio':
        keys = Object.keys(this.model);
        if (keys && keys.length > 0) {
          for (let i = 0; i < keys.length; i++) {
            let radio = id.split('-')[1].indexOf(keys[i]);
            let tabId = 'tab-' + keys[i];
            let tabElement: any = document.getElementById(tabId);
            let inputs = tabElement.getElementsByTagName('input');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier && inputs[j].checked) {
                  inputs[j].checked = false;
                  delete this.model[keys[i]];
                }
              }
            }
          }
        }
        break;
      case 'textarea':
        keys = Object.keys(this.model);
        if (keys && keys.length > 0) {
          for (let i = 0; i < keys.length; i++) {
            let radio = id.split('-')[1].indexOf(keys[i]);
            let tabElement: any = document.getElementById('tab-' + keys[i]);
            let inputs = tabElement.getElementsByTagName('textarea');
            if (inputs && inputs.length && inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
                if (inputs[j]['id'] === identifier) {
                  inputs[j].value = '';
                }
              }
              delete this.model[keys[i]];
            }
          }
        }
        break;
      default:
        let keysDatePicker = Object.keys(this.model);
        if (keysDatePicker && keysDatePicker.length > 0) {
          for (let i = 0; i < keysDatePicker.length; i++) {
            let datePicker = id.split('-')[1].indexOf(keysDatePicker[i]);
            if (datePicker >= 0) {
              this.model[keysDatePicker[i]] = 0;
              delete this.model[keysDatePicker[i]];
            }
          }
        }
        break;
    }
  }

  // Si el checkbox no esta seleccionado, lo elimina del modelo.
  public changeCheckBox(value: any, id: any, ngmodel: any): void {
    // Obtener el elemento.
    var element: any = document.getElementById(id);
    // Eliminar si no esta marcado.
    if (element.checked === false) {
      this.model[id] = undefined;
      delete this.model[id];
    }
    let anyCheckBox = Object.keys(this.model);
    let control = false;
    if (anyCheckBox && anyCheckBox.length > 0) {
      for (let i = 0; i < anyCheckBox.length; i++) {
        if (anyCheckBox[i].includes('checkbox-') && !anyCheckBox[i].includes('checkbox-data')) {
          this.model['checkbox-data'] = true;
          control = true;
        }
      }
      if (control === false) {
        delete this.model['checkbox-data'];
      }
    }
  }

  // Para cerrar acordeon de las autorizaciones.
  public ocultarTabsetss(id: any): void {
    // Ocultar bloque.
    var element: any = document.getElementById(id);
    if (element.style.display === 'none') {
      element.style.display = 'block';
    } else {
      element.style.display = 'none';
    }
    // Para modificar el icono de la cabecera del acordeon.
    this.documentos['authorization'].forEach((e: any) => {
      if (e['authorizationId'] === id) {
        e['visible'] = e['visible'] === false ? true : false;
      }
    });
  }

  // Para cerrar acordeon de las firmas.
  public ocultarSignatures(event: any, ids: any): void {
    this.documentos['signatures'].forEach((e: any) => {
      if (e['signatureId'] === ids) {
        e['visible'] = e['visible'] === false ? true : false;
      }
    });
  }

  // Obtener la firma en cuanto se realiza.
  public changeSignature(id: any): void {
    this.firmas.toArray().forEach((e: any) => {
      // Crear estructura.
      let obj = {
        id: e['element']['id'],
        signature: this.cleanBase64Img(e.getSignature()),
      };
      // Añadir la firma al objeto principal.
      this.documentos.signatures.forEach((element: any, index: number) => {
        if (element.signatureId === obj['id'].split('-')[1]) {
          this.documentos.signatures[index]['signature'] = obj['signature'];
        }
      });
      // Para manejar la visibilidad del boton de borrar.
      this.documentos['signatures'].forEach((element: any) => {
        if (element['signatureId'] === id.split('-')[1]) {
          if (obj['signature']) {
            element['btnVisible'] = true;
          }
        }
      });
    });
    // Comprobar acmpos requeridos para mostar el botón enviar.
    this.requireFields();
  }

  // Para limpiar cada firma.
  public clearSignatureComponentById(id: any): void {
    // Eliminar la firma porn id.
    this.firmas.toArray().forEach((element) => {
      if (element && element['element'] && element['element']['id'] && element['element']['id'] === id) {
        // Borrar la firma.
        element.clear();
      }
    });
    // Para manejar la visibilidad del boton de borrar.
    this.documentos['signatures'].forEach((element: any) => {
      if (element['signatureId'] === id.split('-')[1]) {
        element['btnVisible'] = element['btnVisible'] === false ? true : false;
      }
    });
  }

  // Limpiar imagen en Base64.
  private cleanBase64Img(imgBase64: any): any {
    return imgBase64.substr(imgBase64.indexOf(',') + 1);
  }

  // Enviar las firmas al DMS.
  private postSignatures(token: any, apiDealership: any): void {
    this.respuesta['token'] = token;
    this.respuesta['companyParams'] = apiDealership;
    console.log('[QSigner] Send data: ', this.respuesta);
    this.qsigner.postSignature(this.url, this.respuesta).subscribe((callback: any) => {
      console.log('[QSigner] Response: ', callback);
      if (callback && callback.tokenObj && callback.api) {
        setToken(callback.api, callback.tokenObj, this.storage);
      }
      if (callback && callback['code'] && callback['code'] === 'dms_error') {
        showToaster(this.toastService, 'error', this.translateService, 'COMMON.ERROR', callback['message']);
        this.blockbuttonSend = true;
        this.blockBody = false;
      } else {
        showToaster(this.toastService, 'success', this.translateService, 'COMMON.SUCCESS', 'La información se ha enviado correctamente');
        this.blockbuttonSend = false;
        this.blockBody = false;
        this.sendingData = false;
        /*if(this.qbrowser && this.qbrowser === "true") {
          this.openModal(this.template);
        }*/
        //TODO LLAMADA PARA OBTENER EL SOCKET E INFORMAR DE QUE HE TERMINADO
        let socketID = this.documentId + '*' + this.reference + '*' + this.userUrl + '*' + this.idCliente;
        console.log('socketID', socketID);
        console.log('websocketService', this.websocketService.sendSocket);

        this.websocketService.sendSocket(this.url, { id: socketID }).subscribe((status: any) => {
          console.log('status', status);
          if (status && status['status'] == 'ok' && this.last == 'true') {
            var oWebViewInterface = window['nsWebViewInterface'];
            oWebViewInterface.emit('cerrarDispositivo', true);
          }
        });
      }
    });
  }

  public requireFields(): void {
    // Banderas.
    let isRequiredSignatures: boolean = true;
    let isRequiredAuthorizations: boolean = true;
    // Comprobar firmas requeridas.
    if (this.documentos.signatures && this.documentos.signatures.length) {
      this.documentos.signatures.forEach((element: any) => {
        if (element.required === true) {
          if (element.signature === undefined || element.signature === '') {
            isRequiredSignatures = false;
          }
        }
      });
    }
    // Comprobar autorizaciones requeridas.
    if (this.documentos.authorization && this.documentos.authorization.length) {
      this.documentos.authorization.forEach((element: any) => {
        if (element.required === true) {
          if (element.signature === undefined) {
            isRequiredAuthorizations = false;
          }
        }
      });
    }
    // Deshabilitar o no el botón de enviar.
    if (!isRequiredSignatures || !isRequiredAuthorizations) {
      this.btnSendData = true;
    } else {
      this.btnSendData = false;
    }
  }
}
